// import temp from './middlewares/temp'

module.exports = {
  name: '客戶資料',
  model: 'stores',
  middlewares: [],
  ui: {
    list: {
      columns: [
        { key: 'key', width: 100 },
        { key: 'name', width: 130 },
        { key: 'owner', width: 100 },
        { key: 'CID', width: 100 },
        { key: 'phone', width: 100 },
        { key: 'isOpen', width: 100 },
      ],
    },
    editor: {
      groups: [
        {
          name: '客戶資料',
          rows: [
            [{ key: 'key' }],
            [{ key: 'name' }],
            [{ key: 'fullName' }],
            [{ key: 'storeName' }],
            [{ key: 'owner' }],
            [{ key: 'profitEnterpriseKey' }],
            [{ key: 'CID' }],
            [{ key: 'pharmKey' }],
            [{ key: 'phone' }],
            [{ key: 'phone2' }],
            [{ key: 'fax' }],
            [{ key: 'address' }],
            [{ key: 'storageMA' }],
            [{ key: 'manager' }],
            [{ key: 'isOpen' }],
            [{ key: 'openDate' }],
            [{ key: 'type' }],
            [{ key: 'closeDate' }],
            [{ key: 'level' }],
            [{ key: 'note' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/centerCusts.js